import React from 'react';
import { hookData } from '../data/mock';

const Hook = () => {
  return (
    <section id="about" className="relative py-20 md:py-28 lg:py-36 bg-[#f8f9fa] overflow-hidden">
      <div className="absolute inset-0 noise-bg" />
      
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-20 items-center">
          {/* Image — left on desktop */}
          <div className="relative lg:order-first order-last">
            <div className="relative aspect-[4/3] lg:aspect-[1/1] overflow-hidden">
              <img
                src="/images/about.jpg"
                alt="Abstract glass architecture"
                className="object-cover w-full h-full img-zoom"
              />
            </div>
            {/* Accent frame */}
            <div className="absolute -top-3 -right-3 w-16 md:w-20 h-16 md:h-20 border-t-2 border-r-2 border-[#1a2e4a] hidden sm:block" />
            
            {/* Experience badge */}
            <div className="absolute -bottom-4 -right-4 sm:bottom-6 sm:right-6 bg-[#1a2e4a] text-white px-5 py-4 sm:px-6 sm:py-5 shadow-xl">
              <div className="font-serif text-3xl sm:text-4xl text-[#10b981]">29+</div>
              <div className="text-[10px] sm:text-[11px] tracking-[0.15em] uppercase text-slate-300 mt-1">Years of<br/>Experience</div>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-6 md:space-y-8">
            <div className="flex items-center gap-3">
              <div className="w-8 h-[1.5px] bg-[#10b981]" />
              <span className="text-[11px] tracking-[0.2em] text-[#10b981] uppercase font-semibold">
                Our Philosophy
              </span>
            </div>
            
            <h2 className="font-serif text-[1.75rem] sm:text-[2rem] md:text-[2.5rem] lg:text-[2.85rem] text-[#1a2e4a] leading-[1.12] tracking-[-0.01em]">
              {hookData.headline}
            </h2>
            
            <p className="text-base md:text-lg text-slate-500 leading-[1.75]">
              {hookData.body}
            </p>

            {/* Key points */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 pt-4">
              {[
                { num: '01', text: 'Personalized risk analysis' },
                { num: '02', text: 'Comprehensive portfolio review' },
                { num: '03', text: 'Claims advocacy support' },
                { num: '04', text: 'Ongoing policy optimization' },
              ].map((item) => (
                <div key={item.num} className="flex items-start gap-3 group">
                  <span className="text-sm font-bold text-[#10b981] mt-0.5">{item.num}</span>
                  <span className="text-base text-slate-600 font-medium group-hover:text-[#1a2e4a] transition-colors duration-300">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hook;
